import type { ValueOf } from 'type-fest';

// Reasons for logging out sent to mixpanel
export const LOGOUT_REASON = {
  USER_INITIATED: 'User initiated',
  LOCATIONS_API_ERROR: 'Locations API error',
  REFRESHING_SESSION: 'Error refreshing session',
  WINDOW_VISIBILITY: 'Invalid user ID',
  PRIVATE_ROUTE: 'Accessing private route with different user ID',
  RESTRICTED_ACCESS: 'Restricted access',
  AUTHENTICATION_ERROR: 'Authentication error',
  GUEST_ACCESS_EXPIRED: 'Guest access has expired',
  AUTH0_USER_ALREADY_LOGGED_IN: 'Auth0 user is already logged in',
  GUEST_USER_ALREADY_LOGGED_IN: 'Guest user is already logged in',
  WRONG_CUSTOMER: 'User is logged in with wrong customer',
  SESSION_EXPIRED: 'Session expired',
} as const;

export type LogoutReason = ValueOf<typeof LOGOUT_REASON>;

export const USER_TYPE_ADMIN = 'admin';
export const USER_TYPE_STANDARD = 'standard';
export const USER_TYPE_SOLINK = 'solink';
export const USER_TYPE_CONNECT = 'connect';
export const USER_TYPE_CLOUD = 'cloud';
export const USER_TYPE_RESELLER = 'reseller';
export const USER_TYPE_IMPERSONATOR = 'impersonator'; // Note: This not actually a user type in callhome. It is only defined in Feature Standard to set visibility restrictions.
